import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Container } from '../global'
import { ProgressContext } from '../common/layout/layout'

const StartList = () => {
  const { state, reset } = React.useContext(ProgressContext)
  if (!state) return <>Loading</>

  const {
    quiz_questions_intro: quiz1,
    quiz_questions_life: quiz2,
    quiz_questions_horror: quiz3,
    quiz_questions_reconcile: quiz4,
  } = state

  return (
    <Container>
      <Wrapper>
        <Section to="/intro">
          <div>Lesson 1</div>
          <ProgressDiv
            completed={
              Object.values(quiz1).filter(Boolean).length ===
              Object.values(quiz1).length
            }
          >
            {Object.values(quiz1).filter(Boolean).length}/
            {Object.values(quiz1).length} Completed
          </ProgressDiv>
        </Section>
        <Section to="/life">
          <div>Lesson 2</div>
          <ProgressDiv
            completed={
              Object.values(quiz2).filter(Boolean).length ===
              Object.values(quiz2).length
            }
          >
            {Object.values(quiz2).filter(Boolean).length}/
            {Object.values(quiz2).length} Completed
          </ProgressDiv>
        </Section>
        <Section to="/horrors">
          <div>Lesson 3</div>
          <ProgressDiv
            completed={
              Object.values(quiz3).filter(Boolean).length ===
              Object.values(quiz3).length
            }
          >
            {Object.values(quiz3).filter(Boolean).length}/
            {Object.values(quiz3).length} Completed
          </ProgressDiv>
        </Section>
        <Section to="/reconcile">
          <div>Lesson 4</div>
          <ProgressDiv
            completed={
              Object.values(quiz4).filter(Boolean).length ===
              Object.values(quiz4).length
            }
          >
            {Object.values(quiz4).filter(Boolean).length}/
            {Object.values(quiz4).length} Completed
          </ProgressDiv>
        </Section>
        <ResetButton onClick={() => reset()}>Reset Progress</ResetButton>
      </Wrapper>
    </Container>
  )
}

const Wrapper = styled.div`
  margin-top: 100px;
  display: flex;
  min-height: 80vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: ${props => props.theme.screen.xs}) {
    padding: 0 10px;
  }
`

const Section = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  width: 100%;
  border: 2px solid black;
  height: 50px;
  margin-bottom: 10px;
  text-decoration: none;
  color: black;
`

const ProgressDiv = styled.div`
  color: ${props =>
    props.completed
      ? props.theme.color.green
      : props.theme.color.black.lightest};
`

const ResetButton = styled.div`
  margin-top: 50px;
  cursor: pointer;
`

export default StartList
